<template lang="pug">
leadsplus-layout
  v-container.pt-1.pb-0(fluid grid-list-xl)
    v-layout(row wrap)
      v-flex(xs6)
        action-title-bar(title="LEADS +" is-inline description="" data-cy="leadsplus-title-bar")
  v-container.pt-1(v-if="loaded && isQualifyLoaded" fluid grid-list-xl)
    v-layout(row wrap)
      v-flex(xs4)
        new-leads-widget
      v-flex(xs4)
        contact-status-widget
      v-flex(xs4)
        total-events-widget
    v-layout(row wrap)
      v-flex(xs3)
        active-contacts-widget
      v-flex(xs9)
        qualify-leads-list(
          title="New contacts created",
          is-dashboard,
          hidePreferences,
          subtitle="New leads created as contacts with your Leads+ subscription.",
          :isMock="!isIntegrationConnected",
          leadsource="leadsplus"
        )
  .pa-0.ma-0.leadsplusDialog(v-if="loaded && !isIntegrationConnected")
    v-layout.flex-centered(row wrap xs12)
      v-flex(xs4)
        v-card.dialogCard(xs12, rounded)
          v-card-title.centered.flex-centered
            span.leadsplusFont LEADS+
            br
            span.leadsplusFont.bold Get more leads and win more deals with done-for-you digital marketing
          v-card-text.text-card
            span.bold Boost and LionDesk CRM are coming together to create real estate's premier done-for-you solution for digital marketing plus seller lead generation and qualification.
          v-card-text.text-card
            span.bold Lead Generation & Qualification
            br
            span Select your area and subscribe to Leads+, let us handle the rest. We'll generate leads and qualify sellers via human conversations so you can grow your business. You'll connect with sellers and view progress within your LionDesk account.
          v-card-text.text-card
            span.bold Leads+ Includes:
          v-card-text.text-card
            span.bold Generate:
            br
            span We’ll take care of the marketing by building and optimizing ads and landing pages.
            br
            span Powered by Boost
          v-card-text.text-card
            span.bold Qualify:
            br
            span We’ll do the challenging work of qualifying leads with a mix of human conversations and automation so that you can focus on what you do best, working with sellers.
          v-card-text.text-card
            span.bold Manage:
            br
            span Track and manage your success from lead generation to sale.
            br
            span Powered by LionDesk
          v-card-text.text-card.centered
            span.bold Don't have Leads+ yet?
            br
            span Click to learn more about our done-for-you lead generation system
          v-card-actions.flex-centered
            v-btn.leadsplusColor(@click="openLeadsPlusDashboard") LEARN MORE
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import LeadsplusLayout from '@/Leadsplus/Layout';
import QualifyLeadsList from '../../Core/components/QualifyLeadsList.vue';
import ActiveContactsWidget from './ActiveContactsWidget.vue';
import ContactStatusWidget from './ContactStatusWidget.vue';
import NewLeadsWidget from './NewLeadsWidget.vue';
import TotalEventsWidget from './TotalEventsWidget.vue';
import ActionTitleBar from '../../Core/components/ActionTitleBar.vue';
import NotFound from '../../Core/404.vue';

const {
  mapGetters: mapLeadsplusGetters,
  mapActions: mapLeadsplusActions,
  mapState: mapLeadsplusState,
} = createNamespacedHelpers('leadsplus');
const { mapActions: mapQualifyActions, mapState: mapQualifyState } =
  createNamespacedHelpers('qualify');
const { mapActions: mapBoostActions } = createNamespacedHelpers('boost');
export default {
  name: 'LeadsplusReport',
  components: {
    LeadsplusLayout,
    QualifyLeadsList,
    ActiveContactsWidget,
    ContactStatusWidget,
    NewLeadsWidget,
    TotalEventsWidget,
    ActionTitleBar,
    NotFound,
  },
  data() {
    return {
      checker: {},
    };
  },
  computed: {
    ...mapLeadsplusGetters(['isIntegrationConnected']),
    ...mapLeadsplusState(['loaded']),
    ...mapQualifyState({ isQualifyLoaded: 'loaded' }),
  },
  created() {
    this.getIntegrationStatus();
    this.getQualifyIntegrationStatus();
    this.startChecker();
  },
  beforeDestroy() {
    clearInterval(this.checker);
  },
  methods: {
    ...mapLeadsplusActions(['getIntegrationStatus']),
    ...mapQualifyActions({ getQualifyIntegrationStatus: 'getIntegrationStatus' }),
    ...mapBoostActions(['leadsPlusDashboard']),
    checkStatus() {
      if (!this.isIntegrationConnected) {
        this.getIntegrationStatus(true);
      } else {
        clearInterval(this.checker);
      }
    },
    startChecker() {
      if (!this.isIntegrationConnected) {
        this.checker = setInterval(this.checkStatus, 5000);
      }
    },
    async openLeadsPlusDashboard() {
      const { redirect_url: redirectURL } = await this.leadsPlusDashboard();
      window.open(redirectURL, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.leadsplusColor {
  background-color: #00a567 !important;
  color: white;
}

.leadsplusFont {
  color: #00a567 !important;
  font-size: 20px;
}

.text-card {
  padding-top: 8px;
  padding-bottom: 8px;
}

.leadsplusDialog {
  position: absolute;
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  background-color: rgba(33, 33, 33, 0.46);
  height: 100%;
  top: 0;
  left: 0;
  padding: 4px !important;
}

.relative {
  position: relative;
}

.dialogCard {
  opacity: 1 !important;
}

.flex-centered {
  justify-content: center;
}

.bold {
  font-weight: bold;
}
</style>
